import { defineComponent, ref, watch } from 'vue';

/* eslint-disable no-param-reassign */
var script = defineComponent({
    name: 'TransitionTranslate',
    props: {
        translateX: {
            type: Number,
            default: 0,
        },
        translateY: {
            type: Number,
            default: 0,
        },
    },
    setup(props) {
        const elementStyle = ref({
            transform: `translate(${props.translateX}px, ${props.translateY}px)`,
        });
        watch(() => props.translateX, (newX) => {
            elementStyle.value.transform = `translate(${newX}px, ${props.translateY}px)`;
        });
        watch(() => props.translateY, (newY) => {
            elementStyle.value.transform = `translate(${props.translateX}px, ${newY}px)`;
        });
        const enter = (el) => {
            var _a;
            el.style.transform = (_a = elementStyle.value.transform) !== null && _a !== void 0 ? _a : '';
        };
        const leave = (el) => {
            var _a;
            el.style.transform = (_a = elementStyle.value.transform) !== null && _a !== void 0 ? _a : '';
        };
        return {
            elementStyle,
            enter,
            leave,
        };
    },
});

export { script as default };
